import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';
import { PaginationQuery } from '../interfaces/paginationQuery.interface';
import OrganizationModel from '../models/OrganizationModel';

export const useGetOrganizationList = () => {
  const [isFetchingOrganizationList, setFetchingOrganizationList] = useState(false);
  const [organizationListItems, setOrganizationItems] = useState([]);
  const [organizationCount, setOrganizationCount] = useState<number>(0);

  return {
    isFetchingOrganizationList,
    organizationListItems,
    organizationCount,
    fetchOrganizationList: async (queryParams?: PaginationQuery) => {
      try {
        setFetchingOrganizationList(true);
        const { data } = await AxiosPublic.get('/organizations', {
          params: { ...queryParams, includeUserCount: true },
        });
        const organizationList = data.organizations.map(org => new OrganizationModel(org));
        setOrganizationItems(organizationList);
        setOrganizationCount(data.count);
        setFetchingOrganizationList(false);
      } catch (e) {
        setFetchingOrganizationList(false);
      }
    },
  };
};
